import { SHARED_VARIABLES_REFERENCE_OBJECT } from '../themes/SharedVariablesReferenceObject';
/**
 * @deprecated use SPACINGS_BASE and SpacingNames
 * Use multiples of 4 for all spacing. Defaults to
 * XXS: 4, XS: 8, SM: 16, MD: 20, LG: 24, XL: 32, XXL: 40,
 */

export var MARGINS_BASE = {
  XXS: 4,
  XS: 8,
  SM: 16,
  MD: 20,
  LG: 24,
  XL: 32,
  XXL: 40
};
/**
 * @deprecated use SPACINGS and SpacingNames
 * Defaults to XXS: 4, XS: 8, SM: 16, MD: 20, LG: 24, XL: 32, XXL: 40,
 */

export var MARGINS = SHARED_VARIABLES_REFERENCE_OBJECT.MARGINS;